var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isOpenDeps
    ? _c("div", { staticClass: "setting-container" }, [
        _c("div", { staticClass: "camera-setting-item" }, [
          _c(
            "div",
            { staticClass: "flex items-center justify-between w-full" },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.transition"))),
              ]),
              _c("GrmToggle", {
                attrs: { "is-checked": _vm.isCameraTransition },
                on: {
                  "update:isChecked": function ($event) {
                    _vm.isCameraTransition = $event
                  },
                  "update:is-checked": function ($event) {
                    _vm.isCameraTransition = $event
                  },
                  onChange: _vm.toggleTransitionCamera,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "camera-setting-item" }, [
          _c(
            "div",
            { staticClass: "flex items-center justify-between w-full" },
            [
              _c("p", { staticClass: "my-setting-item-paragraph" }, [
                _vm._v(_vm._s(_vm.$t("camstudy.mySetting.faceMask"))),
              ]),
              _c("GrmToggle", {
                attrs: { "is-checked": _vm.coverFace },
                on: {
                  "update:isChecked": function ($event) {
                    _vm.coverFace = $event
                  },
                  "update:is-checked": function ($event) {
                    _vm.coverFace = $event
                  },
                  onChange: _vm.onFaceMaskChangeHandler,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "camera-setting-item" }, [
          _c(
            "div",
            {
              staticClass: "flex items-center justify-between w-full",
              on: { click: _vm.onOpenDeps },
            },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.blur.title"))),
              ]),
              _c("div", { staticClass: "color-999 flex items-center" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.isCameraBlurActive
                        ? _vm.$t("camstudy.cameraSetting.blur.on")
                        : _vm.$t("camstudy.cameraSetting.blur.off")
                    )
                  ),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                  },
                }),
              ]),
            ]
          ),
          _c("div", { staticClass: "item-description" }, [
            _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.blur.text"))),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "setting-container" }, [
        _c("div", { staticClass: "camera-setting-item" }, [
          _c(
            "div",
            { staticClass: "flex items-center justify-between w-full" },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.blur.title"))),
              ]),
              _c("GrmToggle", {
                attrs: {
                  "is-checked": _vm.isCameraBlurActive,
                  disabled: !_vm.isBlurEnabled,
                },
                on: {
                  "update:isChecked": function ($event) {
                    _vm.isCameraBlurActive = $event
                  },
                  "update:is-checked": function ($event) {
                    _vm.isCameraBlurActive = $event
                  },
                  onDisabled: _vm.onDisabled,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "item-description" }, [
            _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.blur.text"))),
          ]),
        ]),
        _vm.isCameraBlurActive
          ? _c("div", { staticClass: "camera-setting-item" }, [
              _c("div", { staticClass: "flex items-center gap-3 w-full" }, [
                _c("div", { staticClass: "shrink-0" }, [
                  _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.blur.height"))),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.blurVideo.height,
                      expression: "blurVideo.height",
                    },
                  ],
                  staticClass: "custom-slider",
                  style: { "--slider-progress": `${_vm.blurVideo.height}%` },
                  attrs: { type: "range", min: "0", max: "100" },
                  domProps: { value: _vm.blurVideo.height },
                  on: {
                    input: _vm.setBlurVideo,
                    __r: function ($event) {
                      return _vm.$set(
                        _vm.blurVideo,
                        "height",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("div", { staticClass: "shrink-0 color-999" }, [
                  _vm._v(_vm._s(_vm.blurVideo.height) + "%"),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.isCameraBlurActive
          ? _c("div", { staticClass: "camera-setting-item" }, [
              _c("div", { staticClass: "flex items-center gap-3 w-full" }, [
                _c("div", { staticClass: "shrink-0" }, [
                  _vm._v(_vm._s(_vm.$t("camstudy.cameraSetting.blur.power"))),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.blurVideo.blurSize,
                      expression: "blurVideo.blurSize",
                    },
                  ],
                  staticClass: "custom-slider",
                  style: {
                    "--slider-progress": `${
                      (_vm.blurVideo.blurSize / _vm.blurVideo.blurMaxSize) * 100
                    }%`,
                  },
                  attrs: {
                    type: "range",
                    min: "0",
                    max: _vm.blurVideo.blurMaxSize,
                  },
                  domProps: { value: _vm.blurVideo.blurSize },
                  on: {
                    input: _vm.setBlurVideo,
                    __r: function ($event) {
                      return _vm.$set(
                        _vm.blurVideo,
                        "blurSize",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("div", { staticClass: "shrink-0 color-999" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.blurVideo.blurSize / _vm.blurVideo.blurMaxSize) * 100
                    ) + "%"
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }